<template>
  <div  class="wapper">
        <label>{{label}}</label>
        <div class="padded">
          <b-slider
          :step="step"
          :min="min"
          :max="max"
          v-model="sliderValue"
          :value="sliderValue"
          @input="changeValue"
          rounded></b-slider>
        </div>
  </div>
</template>

<script>
export default {
  name:"Slider",
  props:{
    value:{
      type:Number,
      default:0
    },
    label:{
      type:String,
      required:true
    },
    min:{
      type:Number,
      required: false,
      default:0
    
    },
    max:{
      type:Number,
      required: false,
      default:100
    },
    step:{
      type:Number,
      required: false,
      default:1
    }
  },
  data(){
    return{
      sliderValue:0
    }
  },
  methods:{
    changeValue(value){
      this.$emit("input",value)
    }
  },
  mounted(){
    this.sliderValue = this.value
  }
}
</script>

<style lang="scss" scoped>
.wapper{
    text-align: left;
    padding: 0;
}
.padded{
  padding: 0 16px;
}
</style>